import { render, staticRenderFns } from "./AssignmentAITutorLesson.vue?vue&type=template&id=563f02db&scoped=true&"
import script from "./AssignmentAITutorLesson.vue?vue&type=script&lang=js&"
export * from "./AssignmentAITutorLesson.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentAITutorLesson.vue?vue&type=style&index=0&id=563f02db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563f02db",
  null
  
)

export default component.exports